<template>
  <el-main v-loading="loading" style="height:100%">
    <div style="margin-top: 10px;display: flex;justify-content: center">
      <el-select v-model="deptId" size="small"
      placeholder="选择项目" >
          <el-option
            v-for="item in dept"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        size="small"
        style="margin-left: 3px"
        @click="searchClick"
      >搜索</el-button>
    </div>
    <div>
    <div class="container">
      <div class="echart" id="echartProject"></div>
    </div>
  </div>
</el-main>
</template>
<script>
import { getRequest } from '../../utils/api'
export default {
  data () {
    return {
      projectName: [],
      projectNameCount: [],
      myChart: ''
    }
  },
  // 页面初始化挂载dom
  mounted () {
    this.loadStatistsProject()
    // this.getLoadEcharts()
  },
  methods: {
    getLoadEcharts () {
      var option = {
        title: {
          text: '活跃用户',
          subtext: '上一日工作上报情况',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          data: this.projectName
        },
        series: [
          {
            name: '项目',
            type: 'pie',
            radius: '55%',
            center: ['40%', '50%'],
            data: this.projectNameCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.myChart.setOption(option)
    },
    loadStatistsProject () {
      let _this = this
      getRequest('/workload/statisticsProject/0').then(
        resp => {
          _this.projectName = resp.data.data.projectName
          for (var i = 0; i < _this.projectName.length; i++) {
            _this.projectNameCount.push({
              name: _this.projectName[i],
              value: resp.data.data.projectValue[i]
            })
          }
          this.myChart = this.$echarts.init(
            document.getElementById('echartProject')
          )
          this.getLoadEcharts()
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    }
  }
}
</script>
<style scoped>
.title{
  text-align: left;
}
.container{
    width: 80%;
    height: 800px;
}
.echart{
    width: 98%;
    height: 100%;
}
*{
  overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/Views/Statistics/StatisticsProject.vue